import React from "react";
import "./styles.scss";

const PortfolioSingleGrid = props => {
  return (
    <div className="container">
      <div className="row">
        <div className="portfolio-single--grid" leftArrow>{props.children}</div>
      </div>
    </div>
  );
};

export default PortfolioSingleGrid;
